<template>
	<div class="blue-bg footer">
		<div class="container padding40 text-white text-center">
			<div class="row">
				<div class="col-md-4 col-12" style="margin-bottom: 20px;">
					<h3>{{ $t("footer.sitemap") }}</h3>
					<ul class="list">
						<li>
							<a class="link" href="#services">{{ $t("navbar.business") }}</a>
						</li>
						<li>
							<a class="link" href="#references">{{ $t("navbar.ref") }}</a>
						</li>
						<li>
							<a class="link" href="#contact">{{ $t("navbar.contact") }}</a>
						</li>
					</ul>
				</div>
				<div class="col-12 col-md-4" style="margin-bottom: 20px;">
					<img src="../assets/img/logo_white.png" draggable="false" class="img-fluid" style="width: 200px;">
				</div>
				<div class="col-md-4 col-12">
					<h3>{{ $t("footer.contact") }}</h3>
					<ul class="list d-flex">
						<li>
							<a href="https://facebook.com/styleinmotion/" target="_blank" class="link">
								<i class="fa fa-facebook" style="font-size: 22px;"></i>
							</a>
						</li>
						<li>
							<a href="https://www.instagram.com/style_in_motion_studio/ " target="_blank" class="link">
								<i class="fa fa-instagram" style="font-size: 22px;"></i>
							</a>
						</li>
						<li>
							<a href="mailto:info@styleinmotionstudio.com" class="link">
								<i class="fa fa-envelope" style="font-size: 22px;"></i>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue